import ACTIONS from '../actions.js'

export function selectionReducer(state, action) {
  switch (action.type) {
    case ACTIONS.SET_CLIENT: {
      const { clientId, _personal, authTypes, userSecretQuestionList } =
        action.payload
      return {
        ...state,
        clientId,
        _personal,
        authTypes,
        userSecretQuestionList: userSecretQuestionList || null,
        userId: null,
        selectedQuestion: '',
        password: '',
        prompt: '',
        recipients: state.sendEmails ? [{ email: '' }] : [],
      }
    }

    case ACTIONS.SET_SELECTED_FOLDER:
      return {
        ...state,
        selectedFolder: action.value,
      }

    default:
      return state
  }
}

export default selectionReducer
